import { submissionCardsFields, submissionFields } from '../../../../airtable/metadata/submissions';
import { unbox } from '../../../../commons/utils';

export {
  getConfirmedSubmissions,
  getPendingSubmissions,
  getSubmissionCards,
};

function getConfirmedSubmissions(allSubmissions = [], allSubmissionsCards = []) {
  const pendingSubmissions = getPendingSubmissions(allSubmissions);
  const pendingIDs = pendingSubmissions.map(submission => submission.id);

  return allSubmissions.filter(submission => {
    if (pendingIDs.includes(submission.id)) {
      return false;
    }

    const cards = getSubmissionCards(submission, allSubmissionsCards);
    return cards.length > 0;
  });
}

function getPendingSubmissions(allSubmissions = []) {
  return allSubmissions.filter(submission => {
    return submission.total > 0
      && typeof submission.fields[submissionFields.STRIPE_ID] !== 'string';
  });
}

function getSubmissionCards(submission, cards = []) {
  return cards.filter(card => {
    return unbox(card.fields[submissionCardsFields.SUBMISSION_NUMBER])
      === unbox(submission.fields[submissionFields.SUBMISSION_NUMBER]);
  });
}
